import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from 'utils/formatter';
import ShiftDetailRow from '../ShiftDetailRow';

class ShiftDetailCategory extends React.Component {
  render() {
    const {
      paymentMethodCategory,
      refundLabel,
      refundValue,
      expectedLabel,
      expectedValue,
    } = this.props;

    if (!expectedValue && !refundValue) {
      return null;
    }

    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group col-sm-12 label-section">
            <label>{paymentMethodCategory.name}</label>
          </div>
          <div className="col-sm-12 card_detail no-padding-right">
            {this._renderPaymentMethods()}
            {!!refundLabel && (
              <ShiftDetailRow
                label={refundLabel}
                value={currencyFormatter(`-${refundValue}`)}
              />
            )}
            <ShiftDetailRow
              label={expectedLabel}
              value={currencyFormatter(expectedValue)}
            />
          </div>
        </div>
      </div>
    );
  }

  _renderPaymentMethods() {
    const { totalPayments, paymentMethodCategory } = this.props;

    return paymentMethodCategory.paymentMethods
      .filter(paymentMethod => !!totalPayments[paymentMethod.code])
      .map(paymentMethod => (
        <ShiftDetailRow
          key={paymentMethod.code}
          label={paymentMethod.name}
          value={currencyFormatter(totalPayments[paymentMethod.code])}
        />
      ));
  }
}

ShiftDetailCategory.propTypes = {
  totalPayments: PropTypes.object,
  categoryName: PropTypes.string,
  paymentMethodCategory: PropTypes.object,
  refundLabel: PropTypes.string,
  refundValue: PropTypes.number,
  expectedLabel: PropTypes.string,
  expectedValue: PropTypes.number,
};

export default ShiftDetailCategory;
